// extracted by mini-css-extract-plugin
export var banner = "_rb-0";
export var settingRow = "_rb-2";
export var titleIcon = "_rb-1";